"use strict";
// ----------------------------------------------------------------------
// This is an auto generated file from "yarn run icons"
// ----------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
var Icon;
(function (Icon) {
    Icon["Album"] = "album";
    Icon["Ban"] = "ban";
    Icon["Behance"] = "behance";
    Icon["Bell"] = "bell";
    Icon["Bold"] = "bold";
    Icon["Bolt"] = "bolt";
    Icon["Bookmark"] = "bookmark";
    Icon["Calendar"] = "calendar";
    Icon["Camera"] = "camera";
    Icon["Cart"] = "cart";
    Icon["Check"] = "check";
    Icon["Clock"] = "clock";
    Icon["Close"] = "close";
    Icon["Code"] = "code";
    Icon["Cog"] = "cog";
    Icon["Comment"] = "comment";
    Icon["Commenting"] = "commenting";
    Icon["Comments"] = "comments";
    Icon["Copy"] = "copy";
    Icon["Database"] = "database";
    Icon["Desktop"] = "desktop";
    Icon["Download"] = "download";
    Icon["Dribbble"] = "dribbble";
    Icon["Expand"] = "expand";
    Icon["Facebook"] = "facebook";
    Icon["File"] = "file";
    Icon["Flickr"] = "flickr";
    Icon["Folder"] = "folder";
    Icon["Forward"] = "forward";
    Icon["Foursquare"] = "foursquare";
    Icon["Future"] = "future";
    Icon["Github"] = "github";
    Icon["Gitter"] = "gitter";
    Icon["Google"] = "google";
    Icon["Grid"] = "grid";
    Icon["Happy"] = "happy";
    Icon["Hashtag"] = "hashtag";
    Icon["Heart"] = "heart";
    Icon["History"] = "history";
    Icon["Home"] = "home";
    Icon["Image"] = "image";
    Icon["Info"] = "info";
    Icon["Instagram"] = "instagram";
    Icon["Italic"] = "italic";
    Icon["Joomla"] = "joomla";
    Icon["Laptop"] = "laptop";
    Icon["Lifesaver"] = "lifesaver";
    Icon["Link"] = "link";
    Icon["Linkedin"] = "linkedin";
    Icon["List"] = "list";
    Icon["Location"] = "location";
    Icon["Lock"] = "lock";
    Icon["Mail"] = "mail";
    Icon["Menu"] = "menu";
    Icon["Minus"] = "minus";
    Icon["More"] = "more";
    Icon["Move"] = "move";
    Icon["Nut"] = "nut";
    Icon["Pagekit"] = "pagekit";
    Icon["Pencil"] = "pencil";
    Icon["Phone"] = "phone";
    Icon["Pinterest"] = "pinterest";
    Icon["Play"] = "play";
    Icon["Plus"] = "plus";
    Icon["Pull"] = "pull";
    Icon["Push"] = "push";
    Icon["Question"] = "question";
    Icon["Receiver"] = "receiver";
    Icon["Refresh"] = "refresh";
    Icon["Reply"] = "reply";
    Icon["Rss"] = "rss";
    Icon["Search"] = "search";
    Icon["Server"] = "server";
    Icon["Settings"] = "settings";
    Icon["Shrink"] = "shrink";
    Icon["Social"] = "social";
    Icon["Soundcloud"] = "soundcloud";
    Icon["Star"] = "star";
    Icon["Strikethrough"] = "strikethrough";
    Icon["Table"] = "table";
    Icon["Tablet"] = "tablet";
    Icon["Tag"] = "tag";
    Icon["Thumbnails"] = "thumbnails";
    Icon["Trash"] = "trash";
    Icon["Tripadvisor"] = "tripadvisor";
    Icon["Tumblr"] = "tumblr";
    Icon["Tv"] = "tv";
    Icon["Twitter"] = "twitter";
    Icon["Uikit"] = "uikit";
    Icon["Unlock"] = "unlock";
    Icon["Upload"] = "upload";
    Icon["User"] = "user";
    Icon["Users"] = "users";
    Icon["Vimeo"] = "vimeo";
    Icon["Warning"] = "warning";
    Icon["Whatsapp"] = "whatsapp";
    Icon["Wordpress"] = "wordpress";
    Icon["World"] = "world";
    Icon["Xing"] = "xing";
    Icon["Yelp"] = "yelp";
    Icon["Youtube"] = "youtube";
    Icon["Circle"] = "circle";
    Icon["Filter"] = "filter";
    Icon["Minimize"] = "minimize";
    Icon["500px"] = "500px";
    Icon["ArrowDown"] = "arrow-down";
    Icon["ArrowLeft"] = "arrow-left";
    Icon["ArrowRight"] = "arrow-right";
    Icon["ArrowUp"] = "arrow-up";
    Icon["ChevronDown"] = "chevron-down";
    Icon["ChevronLeft"] = "chevron-left";
    Icon["ChevronRight"] = "chevron-right";
    Icon["ChevronUp"] = "chevron-up";
    Icon["CloudDownload"] = "cloud-download";
    Icon["CloudUpload"] = "cloud-upload";
    Icon["CreditCard"] = "credit-card";
    Icon["FileEdit"] = "file-edit";
    Icon["GitBranch"] = "git-branch";
    Icon["GitFork"] = "git-fork";
    Icon["GithubAlt"] = "github-alt";
    Icon["GooglePlus"] = "google-plus";
    Icon["MinusCircle"] = "minus-circle";
    Icon["MoreVertical"] = "more-vertical";
    Icon["PaintBucket"] = "paint-bucket";
    Icon["PhoneLandscape"] = "phone-landscape";
    Icon["PlayCircle"] = "play-circle";
    Icon["PlusCircle"] = "plus-circle";
    Icon["QuoteRight"] = "quote-right";
    Icon["SignIn"] = "sign-in";
    Icon["SignOut"] = "sign-out";
    Icon["TabletLandscape"] = "tablet-landscape";
    Icon["TriangleDown"] = "triangle-down";
    Icon["TriangleLeft"] = "triangle-left";
    Icon["TriangleRight"] = "triangle-right";
    Icon["TriangleUp"] = "triangle-up";
    Icon["VideoCamera"] = "video-camera";
    Icon["CloseCircle"] = "close-circle";
    Icon["CreateCloudShell"] = "create-cloud-shell";
    Icon["ExternalLink"] = "external-link";
    Icon["EyeClosed"] = "eye-closed";
    Icon["EyeOpen"] = "eye-open";
    Icon["RestartCloudShell"] = "restart-cloud-shell";
    Icon["TopmenuCloudShell"] = "topmenu-cloud-shell";
})(Icon || (Icon = {}));
exports.default = Icon;
//# sourceMappingURL=Icon.js.map